"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var axios_1 = __importDefault(require("axios"));
var he_1 = __importDefault(require("he"));
var react_1 = require("react");
var use_state_if_mounted_1 = require("use-state-if-mounted");
require("./styles.css");
var loading_svg_1 = __importDefault(require("./static/loading.svg"));
var Constants = __importStar(require("./constants"));
var AssetDropdownFilter_1 = __importDefault(require("@component/AssetDropdownFilter"));
var AssetResultsGrid_1 = __importDefault(require("@component/AssetResultsGrid"));
var brandcenter_asset_filter_control_1 = __importDefault(require("@rotaryintl/brandcenter-asset-filter-control"));
var StickyFilters_1 = __importDefault(require("@component/StickyFilters"));
//#region Misc Helper Functions
function buildFacet(typeid, label, applyLabel, resetLabel, stateSetter, translate, listType) {
    if (listType && listType.length > 0) {
        var facetList_1 = [];
        listType.map(function (a) {
            if (a.value && a.value.length > 0) {
                facetList_1.push({
                    label: translate(typeid, a.value),
                    value: a.value,
                    count: a.count,
                });
            }
        });
        return {
            id: typeid,
            label: translate(Constants.FacetHeadingId, label),
            filterListData: {
                title: label,
                filterCheckboxData: facetList_1,
                applyButton: applyLabel,
                resetButton: resetLabel,
            },
            applyFacets: stateSetter,
            resetFacets: function () {
                console.log("reset facets");
            }, //todo unused
        };
    }
    return {};
}
function convertToDate(unix) {
    if (unix && unix.length > 0) {
        var date = new Date(Number(unix));
        var months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        var year = date.getFullYear();
        var month = months[date.getMonth()];
        var day = date.getDate();
        return day + "-" + month + "-" + year;
    }
    return "";
}
function ToQueryString(prefix, searchTerm, filterList, language) {
    if (typeof document !== "undefined" && typeof window !== "undefined") {
        var urlSearchParams_1 = new URLSearchParams(location.search);
        //set q= if available
        if (searchTerm && searchTerm.length > 0) {
            urlSearchParams_1.set(Constants.SearchTermQueryParam, searchTerm);
        }
        else {
            urlSearchParams_1.delete(Constants.SearchTermQueryParam);
        }
        //set lang= if available
        var langParm = prefix + Constants.LanguageQueryParam;
        if (language && language.length > 0) {
            urlSearchParams_1.delete(langParm);
            urlSearchParams_1.set(langParm, language);
        }
        else {
            urlSearchParams_1.delete(langParm);
        }
        //set filters
        var scrubbedFilterList_1 = filterList === null || filterList === void 0 ? void 0 : filterList.filter(function (type) { return type.field !== Constants.BrandcenterTypeField; });
        scrubbedFilterList_1 === null || scrubbedFilterList_1 === void 0 ? void 0 : scrubbedFilterList_1.map(function (item) {
            var _a;
            var paramKey = prefix + ((_a = item.field) === null || _a === void 0 ? void 0 : _a.toLowerCase());
            urlSearchParams_1.set(paramKey, item.value);
        });
        //if all values are removed from a filter category, clean up
        urlSearchParams_1.forEach(function (value, key) {
            var inFilters = scrubbedFilterList_1.find(function (item) { var _a; return prefix + ((_a = item.field) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === key; });
            if (key.includes(prefix) &&
                !inFilters &&
                !key.includes(prefix + Constants.LanguageQueryParam)) {
                urlSearchParams_1.delete(key);
            }
        });
        window.history.replaceState({}, "", location.pathname + "?" + urlSearchParams_1);
    }
}
function GetLanguageNameByAbbrv(abrv) {
    switch (abrv === null || abrv === void 0 ? void 0 : abrv.toUpperCase()) {
        case Constants.GermanAbbrv:
            return Constants.German;
        case Constants.EnglishAbbrv:
            return Constants.English;
        case Constants.SpanishAbbrv:
            return Constants.Spanish;
        case Constants.FrenchAbbrv:
            return Constants.French;
        case Constants.ItalianAbbrv:
            return Constants.Italian;
        case Constants.JapaneseAbbrv:
            return Constants.Japanese;
        case Constants.KoreanAbbrv:
            return Constants.Korean;
        case Constants.PortugueseAbbrv:
            return Constants.Portuguese;
        case Constants.ChineseAbbrv:
            return Constants.Chinese;
        default:
            return null;
    }
}
function GetAbbrFromLanguageName(lang) {
    switch (lang) {
        case Constants.German:
            return Constants.GermanAbbrv;
        case Constants.English:
            return Constants.EnglishAbbrv;
        case Constants.Spanish:
            return Constants.SpanishAbbrv;
        case Constants.French:
            return Constants.FrenchAbbrv;
        case Constants.Italian:
            return Constants.ItalianAbbrv;
        case Constants.Japanese:
            return Constants.JapaneseAbbrv;
        case Constants.Korean:
            return Constants.KoreanAbbrv;
        case Constants.Portuguese:
            return Constants.PortugueseAbbrv;
        case Constants.Chinese:
            return Constants.ChineseAbbrv;
        default:
            return "";
    }
}
function CreateGraphQLVariablesList(arr) {
    var graphQLFilters = [];
    var dict = new Map();
    arr === null || arr === void 0 ? void 0 : arr.map(function (item) {
        var _a;
        //build dictionary of filters with OR-logic
        var cleanFilterType = item.filterType.replace(/[^a-zA-Z]/g, "");
        var existingFilterType = (_a = dict.get(cleanFilterType)) !== null && _a !== void 0 ? _a : "";
        var composedFilter = existingFilterType
            ? existingFilterType + "|" + item.filterValue
            : item.filterValue;
        dict.set(cleanFilterType, composedFilter);
    });
    //build new graphQL variable filter
    dict.forEach(function (value, key) {
        graphQLFilters.push({
            field: key,
            value: value,
        });
    });
    return graphQLFilters;
}
function CreateFoundForList(arr, translate) {
    var assetTypeStrings = [];
    arr === null || arr === void 0 ? void 0 : arr.map(function (item) {
        //build asset type list
        assetTypeStrings.push(translate(item.typeid, item.filterValue));
    });
    return assetTypeStrings;
}
function CreateStickyFiltersList(arr, translate) {
    var translatedFilters = [];
    arr === null || arr === void 0 ? void 0 : arr.map(function (item) {
        //build translated sticky filters
        translatedFilters.push(__assign(__assign({}, item), { filterTypeLabel: translate(Constants.FacetHeadingId, item.filterType), filterLabel: translate(item.typeid, item.filterValue) }));
    });
    return translatedFilters;
}
function GetFilesize(filesize, props) {
    var num = parseFloat(filesize);
    if (num < 1) {
        return num * 1000 + " " + props.kilobyteLabel;
    }
    else if (num >= 1000) {
        return num / 1000 + " " + props.gigabyteLabel;
    }
    return num + " " + props.megabyteLabel;
}
function writeDDO(doc, eventType, downloadFileType, isStandalone, searchTerm) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    if (typeof window !== "undefined") {
        var event_1 = {
            eventType: eventType || "",
            assetId: (doc === null || doc === void 0 ? void 0 : doc.Id) || "",
            filename: (doc === null || doc === void 0 ? void 0 : doc.Filename) || "",
            filetype: (doc === null || doc === void 0 ? void 0 : doc.Filetype) || "",
            title: (doc === null || doc === void 0 ? void 0 : doc.EN_Title) || "",
            brandcenterType: (doc === null || doc === void 0 ? void 0 : doc.BrandcenterType) || "",
            assetType: (doc === null || doc === void 0 ? void 0 : doc.AssetType) || [],
            assetSubType: (doc === null || doc === void 0 ? void 0 : doc.AssetSubType) || [],
            language: (doc === null || doc === void 0 ? void 0 : doc.Language) || "",
            chiliTemplateId: (doc === null || doc === void 0 ? void 0 : doc.ChiliTemplateId) || "",
            logoDownloadedAsFiletype: downloadFileType || "",
            standAlonePage: isStandalone || "",
        };
        var urlSearchParams = new URLSearchParams(location.search);
        var facetData = {
            dt_assettype: ((_a = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get(Constants.DownloadsTabPrefix + Constants.AssetTypeId)) === null || _a === void 0 ? void 0 : _a.replace(/\|/g, ",")) || "",
            dt_assetsubtype: ((_b = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get(Constants.DownloadsTabPrefix + Constants.AssetSubTypeId)) === null || _b === void 0 ? void 0 : _b.replace(/\|/g, ",")) || "",
            dt_campaign: ((_c = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get(Constants.DownloadsTabPrefix + Constants.CampaignTypeId)) === null || _c === void 0 ? void 0 : _c.replace(/\|/g, ",")) || "",
            dt_keyword: ((_d = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get(Constants.DownloadsTabPrefix + Constants.KeywordTypeId)) === null || _d === void 0 ? void 0 : _d.replace(/\|/g, ",")) || "",
            dt_ourcauses: ((_e = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get(Constants.DownloadsTabPrefix + Constants.OurCausesTypeId)) === null || _e === void 0 ? void 0 : _e.replace(/\|/g, ",")) || "",
            dt_lang: ((_f = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get(Constants.DownloadsTabPrefix + Constants.LanguageQueryParam)) === null || _f === void 0 ? void 0 : _f.replace(/\|/g, ",")) || "",
            dt_region: ((_g = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get(Constants.DownloadsTabPrefix + Constants.RegionTypeId)) === null || _g === void 0 ? void 0 : _g.replace(/\|/g, ",")) || "",
            tt_assettype: ((_h = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get(Constants.TemplatesTabPrefix + Constants.AssetTypeId)) === null || _h === void 0 ? void 0 : _h.replace(/\|/g, ",")) || "",
            tt_assetsubtype: ((_j = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get(Constants.TemplatesTabPrefix + Constants.AssetSubTypeId)) === null || _j === void 0 ? void 0 : _j.replace(/\|/g, ",")) || "",
            tt_campaign: ((_k = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get(Constants.TemplatesTabPrefix + Constants.CampaignTypeId)) === null || _k === void 0 ? void 0 : _k.replace(/\|/g, ",")) || "",
            tt_keyword: ((_l = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get(Constants.TemplatesTabPrefix + Constants.KeywordTypeId)) === null || _l === void 0 ? void 0 : _l.replace(/\|/g, ",")) || "",
            tt_ourcauses: ((_m = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get(Constants.TemplatesTabPrefix + Constants.OurCausesTypeId)) === null || _m === void 0 ? void 0 : _m.replace(/\|/g, ",")) || "",
            tt_lang: ((_o = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get(Constants.TemplatesTabPrefix + Constants.LanguageQueryParam)) === null || _o === void 0 ? void 0 : _o.replace(/\|/g, ",")) || "",
            tt_region: ((_p = urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get(Constants.TemplatesTabPrefix + Constants.RegionTypeId)) === null || _p === void 0 ? void 0 : _p.replace(/\|/g, ",")) || "",
            tab: (urlSearchParams === null || urlSearchParams === void 0 ? void 0 : urlSearchParams.get("tab")) || "",
        };
        var searchData = {
            searchTerm: searchTerm || "",
            query: ((_q = window.location) === null || _q === void 0 ? void 0 : _q.search) || "",
            state: facetData,
        };
        window.rotaryDDO.assetExplorerEvent = event_1;
        window.rotaryDDO.searchData = searchData;
        // console.log(window.rotaryDDO);
    }
}
function getRelatedFiles(doc, language, props, title, langPrefix) {
    var _a;
    var relatedFiles = [];
    if (((_a = doc.RelatedAssets) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        var parsedRelatedAssets = JSON.parse(doc.RelatedAssets);
        parsedRelatedAssets === null || parsedRelatedAssets === void 0 ? void 0 : parsedRelatedAssets.map(function (file) {
            var _a;
            if ((file.Language === doc.Language ||
                file.Language === "Any" ||
                file.Language === language) &&
                ((_a = file[title]) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                var url = props.shareUrl + "?id=" + file.Id + "&lang=" + langPrefix;
                relatedFiles.push({ id: file.Id, title: file[title], url: url });
            }
        });
    }
    return relatedFiles;
}
//#endregion
//#region Build Modal callbacks
function buildImageModal(doc, idx, props, langPrefix, language, searchTerm) {
    var title = langPrefix + "_Title";
    var desc = langPrefix + "_Description";
    var url = props.shareUrl + "?id=" + doc.Id + "&lang=" + langPrefix;
    var wtu = langPrefix + "_WhenToUse";
    var relatedFiles = getRelatedFiles(doc, language, props, title, langPrefix);
    var modal = {
        index: idx,
        type: Constants.ImageType.toLowerCase(),
        grid: {
            file: ((0, jsx_runtime_1.jsx)("img", { src: doc.ThumbnailUrl || props.fallbackImage, width: "100%", height: "100%", alt: doc[title] || doc.Filename })),
            title: doc[title] || doc.Filename, //LANG_Title
        },
        slide: {
            media: {
                file: ((0, jsx_runtime_1.jsx)("img", { src: doc.ThumbnailUrl || props.fallbackImage, width: "100%", height: "100%", alt: doc[title] || doc.Filename })),
                share: url || doc.ThumbnailUrl, //ThumbnailUrl
            },
            content: {
                title: doc[title] || doc.Filename,
                description: doc[desc],
                whenToUse: {
                    whenToUseTitle: props.whenToUseLabel,
                    whenToUseDescription: doc[wtu],
                },
                relatedFiles: {
                    title: props.relatedFilesLabel,
                    link: relatedFiles,
                },
                viewDetails: {
                    view: props.viewDetailsLabel,
                    fileName: doc.Filename,
                    fileType: doc.Filetype,
                    fileSize: GetFilesize(doc.Filesize, props),
                    assetLanguage: props.findTranslation(Constants.LanguagesTypeId, doc.Language),
                    // fileCreated: convertToDate(doc.DateCreated), //removed from user story
                },
                cta: props.downloadButtonLabel,
                handleClick: function () {
                    if (typeof document !== "undefined" &&
                        typeof window !== "undefined") {
                        var link = document.createElement("a");
                        link.href = doc.DirectDownloadLink;
                        link.setAttribute("target", "_blank");
                        link.setAttribute("download", doc.Filename);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        writeDDO(doc, "Download", "", "0", searchTerm);
                    }
                },
                dropdown: null,
                termsOfUse: props.termsOfUse,
                shareLabel: props.shareLabel,
                shareLinkLabel: props.shareLinkLabel,
                copyLabel: props.copyLabel,
                copiedLabel: props.copiedLabel,
                embedLabel: props.embedLabel,
                chooseFileTypeLabel: props.chooseFileTypeLabel,
                fileNameLabel: props.fileNameLabel,
                fileTypeLabel: props.fileTypeLabel,
                fileSizeLabel: props.fileSizeLabel,
                assetLanguageLabel: props.assetLanguageLabel,
            },
        },
        writeDDO: function (eventType) {
            writeDDO(doc, eventType, "", "0", searchTerm);
        },
    };
    return modal;
}
function buildTemplateModal(doc, idx, props, langPrefix, language, searchTerm) {
    var title = langPrefix + "_Title";
    var desc = langPrefix + "_Description";
    var wtu = langPrefix + "_WhenToUse";
    var url = props.shareUrl + "?id=" + doc.Id + "&lang=" + langPrefix;
    var relatedFiles = getRelatedFiles(doc, language, props, title, langPrefix);
    var modal = {
        index: idx,
        type: Constants.TemplateType.toLowerCase(),
        grid: {
            file: ((0, jsx_runtime_1.jsx)("img", { src: doc.ThumbnailUrl || props.fallbackImage, width: "100%", height: "100%", alt: doc[title] || doc.Filename })),
            title: doc[title] || doc.Filename, //LANG_Title
        },
        slide: {
            media: {
                file: ((0, jsx_runtime_1.jsx)("img", { src: doc.ThumbnailUrl || props.fallbackImage, width: "100%", height: "100%", alt: doc[title] || doc.Filename })),
                share: url || doc.ThumbnailUrl,
            },
            content: {
                title: doc[title] || doc.Filename,
                description: doc[desc],
                note: {
                    noteTitle: props.modalNoteLabel,
                    noteDescription: props.modalNoteText,
                },
                whenToUse: {
                    whenToUseTitle: props.whenToUseLabel,
                    whenToUseDescription: doc[wtu],
                },
                relatedFiles: {
                    title: props.relatedFilesLabel,
                    link: relatedFiles,
                },
                viewDetails: null,
                cta: props.createButtonLabel,
                handleClick: function () {
                    var _a, _b, _c, _d;
                    var target = ((_a = props.templateCreateLink) === null || _a === void 0 ? void 0 : _a.target) === ""
                        ? "_self"
                        : (_b = props.templateCreateLink) === null || _b === void 0 ? void 0 : _b.target;
                    ((_c = props.templateCreateLink) === null || _c === void 0 ? void 0 : _c.href) &&
                        window.open(((_d = props.templateCreateLink) === null || _d === void 0 ? void 0 : _d.href) + "?id=" + doc.ChiliTemplateId, target);
                    writeDDO(doc, "Create", "", "0", searchTerm);
                },
                dropdown: null,
                termsOfUse: props.termsOfUse,
                shareLabel: props.shareLabel,
                shareLinkLabel: props.shareLinkLabel,
                copyLabel: props.copyLabel,
                copiedLabel: props.copiedLabel,
                embedLabel: props.embedLabel,
                chooseFileTypeLabel: props.chooseFileTypeLabel,
                fileNameLabel: props.fileNameLabel,
                fileTypeLabel: props.fileTypeLabel,
                fileSizeLabel: props.fileSizeLabel,
                assetLanguageLabel: props.assetLanguageLabel,
            },
        },
        writeDDO: function (eventType) {
            writeDDO(doc, eventType, "", "0", searchTerm);
        },
    };
    return modal;
}
function buildDocumentModal(doc, idx, props, langPrefix, language, searchTerm) {
    var title = langPrefix + "_Title";
    var desc = langPrefix + "_Description";
    var wtu = langPrefix + "_WhenToUse";
    var url = props.shareUrl + "?id=" + doc.Id + "&lang=" + langPrefix;
    var relatedFiles = getRelatedFiles(doc, language, props, title, langPrefix);
    var modal = {
        index: idx,
        type: Constants.DocumentType.toLowerCase(),
        grid: {
            file: ((0, jsx_runtime_1.jsx)("img", { src: doc.ThumbnailUrl || props.fallbackImage, width: "100%", height: "100%", alt: doc[title] || doc.Filename })),
            title: doc[title] || doc.Filename,
        },
        slide: {
            media: {
                file: ((0, jsx_runtime_1.jsx)("img", { src: doc.ThumbnailUrl || props.fallbackImage, width: "100%", height: "100%", alt: doc[title] })),
                share: url || doc.ThumbnailUrl,
            },
            content: {
                title: doc[title],
                description: doc[desc],
                whenToUse: {
                    whenToUseTitle: props.whenToUseLabel,
                    whenToUseDescription: doc[wtu],
                },
                relatedFiles: {
                    title: props.relatedFilesLabel,
                    link: relatedFiles,
                },
                viewDetails: {
                    view: props.viewDetailsLabel,
                    fileName: doc.Filename,
                    fileType: doc.Filetype,
                    fileSize: GetFilesize(doc.Filesize, props),
                    assetLanguage: props.findTranslation(Constants.LanguagesTypeId, doc.Language),
                    // fileCreated: convertToDate(doc.DateCreated), //removed from user story
                },
                cta: props.downloadButtonLabel,
                handleClick: function () {
                    if (typeof document !== "undefined" &&
                        typeof window !== "undefined") {
                        var link = document.createElement("a");
                        link.href = doc.DirectDownloadLink;
                        link.setAttribute("target", "_blank");
                        link.setAttribute("download", doc.Filename);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        writeDDO(doc, "Download", "", "0", searchTerm);
                    }
                },
                dropdown: null,
                termsOfUse: props.termsOfUse,
                shareLabel: props.shareLabel,
                shareLinkLabel: props.shareLinkLabel,
                copyLabel: props.copyLabel,
                copiedLabel: props.copiedLabel,
                embedLabel: props.embedLabel,
                chooseFileTypeLabel: props.chooseFileTypeLabel,
                fileNameLabel: props.fileNameLabel,
                fileTypeLabel: props.fileTypeLabel,
                fileSizeLabel: props.fileSizeLabel,
                assetLanguageLabel: props.assetLanguageLabel,
            },
        },
        writeDDO: function (eventType) {
            writeDDO(doc, eventType, "", "0", searchTerm);
        },
    };
    return modal;
}
function buildLogoModal(doc, idx, props, langPrefix, language, searchTerm) {
    var title = langPrefix + "_Title";
    var desc = langPrefix + "_Description";
    var wtu = langPrefix + "_WhenToUse";
    var url = props.shareUrl + "?id=" + doc.Id + "&lang=" + langPrefix;
    var logoDownloadValue = "";
    var relatedFiles = getRelatedFiles(doc, language, props, title, langPrefix);
    var modal = {
        index: idx,
        type: Constants.LogoType.toLowerCase(),
        grid: {
            file: ((0, jsx_runtime_1.jsx)("img", { src: doc.ThumbnailUrl || props.fallbackImage, width: "100%", height: "auto", alt: doc[title] || doc.Filename, style: { background: "#eeeeee" } })),
            title: doc[title] || doc.Filename,
            handleClick: function () {
                console.log("handleClick"); //todo unused
            },
        },
        slide: {
            media: {
                file: ((0, jsx_runtime_1.jsx)("img", { src: doc.ThumbnailUrl || props.fallbackImage, width: "100%", height: "auto", alt: doc[title] || doc.Filename, style: { background: "#eeeeee" } })),
                share: url || doc.ThumbnailUrl,
            },
            content: {
                title: doc[title],
                description: doc[desc],
                whenToUse: {
                    whenToUseTitle: props.whenToUseLabel,
                    whenToUseDescription: doc[wtu],
                },
                relatedFiles: {
                    title: props.relatedFilesLabel,
                    link: relatedFiles,
                },
                viewDetails: {
                    view: props.viewDetailsLabel,
                    fileName: doc.Filename,
                    fileSize: null,
                    assetLanguage: props.findTranslation(Constants.LanguagesTypeId, doc.Language),
                    // fileCreated: convertToDate(doc.DateCreated), //removed from user story
                },
                dropdown: {
                    Title: props.chooseFileTypeLabel,
                    options: [
                        { id: "0", label: "EPS", value: doc.DirectDownloadLink },
                        { id: "1", label: "PNG", value: doc.LogoPngUrl },
                        { id: "2", label: "JPG", value: doc.LogoJpgUrl },
                    ],
                    selected: "EPS",
                    selectedValue: doc.DirectDownloadLink,
                    errorMessage: props.gridLoadErrorText,
                },
                cta: props.downloadButtonLabel,
                handleClick: function (e) {
                    var _a;
                    if (typeof document !== "undefined" &&
                        typeof window !== "undefined") {
                        try {
                            var link = document.createElement("a");
                            var selectedOption = e
                                .closest(".asset_explorer_right_details_content")
                                .getElementsByTagName("select")[0];
                            link.href = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value;
                            link.setAttribute("target", "_blank");
                            document.body.appendChild(link);
                            link.click();
                            link.remove();
                            var errorDiv = e
                                .closest(".asset_explorer_right_details_content")
                                .getElementsByClassName("dropdown_error_message")[0];
                            errorDiv.style.display = "none";
                            logoDownloadValue =
                                (_a = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.options[selectedOption.selectedIndex]) === null || _a === void 0 ? void 0 : _a.text;
                            writeDDO(doc, "Download", logoDownloadValue, "0", searchTerm);
                        }
                        catch (error) {
                            var errorDiv = e
                                .closest(".asset_explorer_right_details_content")
                                .getElementsByClassName("dropdown_error_message")[0];
                            errorDiv.style.display = "";
                        }
                    }
                },
                termsOfUse: props.termsOfUse,
                shareLabel: props.shareLabel,
                shareLinkLabel: props.shareLinkLabel,
                copyLabel: props.copyLabel,
                copiedLabel: props.copiedLabel,
                embedLabel: props.embedLabel,
                chooseFileTypeLabel: props.chooseFileTypeLabel,
                fileNameLabel: props.fileNameLabel,
                fileTypeLabel: props.fileTypeLabel,
                fileSizeLabel: props.fileSizeLabel,
                assetLanguageLabel: props.assetLanguageLabel,
            },
        },
        writeDDO: function (eventType) {
            writeDDO(doc, eventType, logoDownloadValue, "0", searchTerm);
        },
    };
    return modal;
}
function buildAudioModal(doc, idx, props, langPrefix, language, searchTerm) {
    var title = langPrefix + "_Title";
    var desc = langPrefix + "_Description";
    var wtu = langPrefix + "_WhenToUse";
    var url = props.shareUrl + "?id=" + doc.Id + "&lang=" + langPrefix;
    var relatedFiles = getRelatedFiles(doc, language, props, title, langPrefix);
    var modal = {
        index: idx,
        type: Constants.AudioType.toLowerCase(),
        grid: {
            file: ((0, jsx_runtime_1.jsx)("img", { src: doc.ThumbnailUrl || props.fallbackImage, width: "100%", height: "100%", alt: doc[title] || doc.Filename })),
            title: doc[title] || doc.Filename,
            handleClick: function () {
                console.log("handleClick in grid"); //todo what is this for?
            },
        },
        slide: {
            media: {
                file: doc.AudioUrl,
                share: url || doc.AudioUrl,
            },
            content: {
                title: doc[title],
                description: doc[desc],
                whenToUse: {
                    whenToUseTitle: props.whenToUseLabel,
                    whenToUseDescription: doc[wtu],
                },
                relatedFiles: {
                    title: props.relatedFilesLabel,
                    link: relatedFiles,
                },
                viewDetails: {
                    view: props.viewDetailsLabel,
                    fileName: doc.Filename,
                    fileType: doc.Filetype,
                    fileSize: GetFilesize(doc.Filesize, props),
                    assetLanguage: props.findTranslation(Constants.LanguagesTypeId, doc.Language),
                    // fileCreated: convertToDate(doc.DateCreated), //removed in user story
                },
                cta: props.downloadButtonLabel,
                handleClick: function () {
                    if (typeof document !== "undefined" &&
                        typeof window !== "undefined") {
                        var link = document.createElement("a");
                        link.href = doc.DirectDownloadLink;
                        link.setAttribute("target", "_blank");
                        link.setAttribute("download", doc.Filename);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                    writeDDO(doc, "Download", "", "0", searchTerm);
                },
                dropdown: null,
                termsOfUse: props.termsOfUse,
                shareLabel: props.shareLabel,
                shareLinkLabel: props.shareLinkLabel,
                copyLabel: props.copyLabel,
                copiedLabel: props.copiedLabel,
                embedLabel: props.embedLabel,
                chooseFileTypeLabel: props.chooseFileTypeLabel,
                fileNameLabel: props.fileNameLabel,
                fileTypeLabel: props.fileTypeLabel,
                fileSizeLabel: props.fileSizeLabel,
                assetLanguageLabel: props.assetLanguageLabel,
            },
        },
        writeDDO: function (eventType) {
            writeDDO(doc, eventType, "", "0", searchTerm);
        },
    };
    return modal;
}
function buildVideoModal(doc, idx, props, langPrefix, language, searchTerm) {
    var title = langPrefix + "_Title";
    var desc = langPrefix + "_Description";
    var wtu = langPrefix + "_WhenToUse";
    var url = props.shareUrl + "?id=" + doc.Id + "&lang=" + langPrefix;
    var relatedFiles = getRelatedFiles(doc, language, props, title, langPrefix);
    var modal = {
        index: idx,
        type: Constants.VideoType.toLowerCase(),
        grid: {
            file: ((0, jsx_runtime_1.jsx)("img", { src: doc.ThumbnailUrl || props.fallbackImage, width: "100%", height: "100%", alt: doc[title] || doc.Filename })),
            title: doc[title] || doc.Filename,
            handleClick: function () {
                console.log("video click"); //todo what is this used for
            },
        },
        slide: {
            media: {
                file: doc.DirectLink,
                share: url || doc.DirectDownloadLink,
                embed: he_1.default.decode(doc.EmbedCode),
            },
            content: {
                title: doc[title],
                description: doc[desc],
                whenToUse: {
                    whenToUseTitle: props.whenToUseLabel,
                    whenToUseDescription: doc[wtu],
                },
                relatedFiles: {
                    title: props.relatedFilesLabel,
                    link: relatedFiles,
                },
                viewDetails: {
                    view: props.viewDetailsLabel,
                    fileName: doc.Filename,
                    fileType: doc.Filetype,
                    fileSize: GetFilesize(doc.Filesize, props),
                    assetLanguage: props.findTranslation(Constants.LanguagesTypeId, doc.Language),
                    // fileCreated: convertToDate(doc.DateCreated), //removed from the user stories
                },
                cta: props.downloadButtonLabel,
                handleClick: function () {
                    if (typeof document !== "undefined" &&
                        typeof window !== "undefined") {
                        var link = document.createElement("a");
                        link.href = doc.DirectDownloadLink;
                        link.setAttribute("target", "_blank");
                        link.setAttribute("download", doc.Filename);
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }
                    writeDDO(doc, "Download", "", "0", searchTerm);
                },
                dropdown: null,
                termsOfUse: props.termsOfUse,
                shareLabel: props.shareLabel,
                shareLinkLabel: props.shareLinkLabel,
                copyLabel: props.copyLabel,
                copiedLabel: props.copiedLabel,
                embedLabel: props.embedLabel,
                chooseFileTypeLabel: props.chooseFileTypeLabel,
                fileNameLabel: props.fileNameLabel,
                fileTypeLabel: props.fileTypeLabel,
                fileSizeLabel: props.fileSizeLabel,
                assetLanguageLabel: props.assetLanguageLabel,
            },
        },
        writeDDO: function (eventType) {
            writeDDO(doc, eventType, "", "0", searchTerm);
        },
    };
    return modal;
}
//#endregion
//#region Build Facet and Result Lists
//Build results grid
function buildResultList(axiosResponse, props, langPrefix, language, searchTerm) {
    var _a, _b, _c;
    var resultList = [];
    var indexCount = 0;
    (_c = (_b = (_a = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data) === null || _a === void 0 ? void 0 : _a.searchWebdam) === null || _b === void 0 ? void 0 : _b.results) === null || _c === void 0 ? void 0 : _c.map(function (item, idx) {
        var _a, _b, _c, _d, _e, _f;
        if (((_a = item.document) === null || _a === void 0 ? void 0 : _a.BrandcenterType) === Constants.ImageType) {
            resultList.push(buildImageModal(item.document, indexCount, props, langPrefix, language, searchTerm));
            indexCount++;
        }
        if (((_b = item.document) === null || _b === void 0 ? void 0 : _b.BrandcenterType) === Constants.TemplateType) {
            resultList.push(buildTemplateModal(item.document, indexCount, props, langPrefix, language, searchTerm));
            indexCount++;
        }
        if (((_c = item.document) === null || _c === void 0 ? void 0 : _c.BrandcenterType) === Constants.DocumentType) {
            resultList.push(buildDocumentModal(item.document, indexCount, props, langPrefix, language, searchTerm));
            indexCount++;
        }
        if (((_d = item.document) === null || _d === void 0 ? void 0 : _d.BrandcenterType) === Constants.LogoType) {
            resultList.push(buildLogoModal(item.document, indexCount, props, langPrefix, language, searchTerm));
            indexCount++;
        }
        if (((_e = item.document) === null || _e === void 0 ? void 0 : _e.BrandcenterType) === Constants.AudioType) {
            resultList.push(buildAudioModal(item.document, indexCount, props, langPrefix, language, searchTerm));
            indexCount++;
        }
        if (((_f = item.document) === null || _f === void 0 ? void 0 : _f.BrandcenterType) === Constants.VideoType) {
            resultList.push(buildVideoModal(item.document, indexCount, props, langPrefix, language, searchTerm));
            indexCount++;
        }
    });
    return resultList;
}
//Build Facet dropdowns (filterList)
function buildFacetList(axiosResponse, props, handleFilterChange, translate) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    var filterList = [];
    filterList.push(buildFacet(Constants.AssetTypeId, Constants.AssetTypeFilter, props.applyLabel, props.resetLabel, handleFilterChange, translate, (_b = (_a = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data) === null || _a === void 0 ? void 0 : _a.searchWebdam) === null || _b === void 0 ? void 0 : _b.facets.AssetType.filter(function (i) { return i.value !== ""; })));
    filterList.push(buildFacet(Constants.AssetSubTypeId, Constants.AssetSubTypeFilter, props.applyLabel, props.resetLabel, handleFilterChange, translate, (_d = (_c = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data) === null || _c === void 0 ? void 0 : _c.searchWebdam) === null || _d === void 0 ? void 0 : _d.facets.AssetSubType.filter(function (i) { return i.value !== ""; })));
    filterList.push(buildFacet(Constants.CampaignTypeId, Constants.CampaignTypeFilter, props.applyLabel, props.resetLabel, handleFilterChange, translate, (_f = (_e = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data) === null || _e === void 0 ? void 0 : _e.searchWebdam) === null || _f === void 0 ? void 0 : _f.facets.Campaign.filter(function (i) { return i.value !== ""; })));
    filterList.push(buildFacet(Constants.OurCausesTypeId, Constants.OurCausesTypeFilter, props.applyLabel, props.resetLabel, handleFilterChange, translate, (_h = (_g = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data) === null || _g === void 0 ? void 0 : _g.searchWebdam) === null || _h === void 0 ? void 0 : _h.facets.OurCauses.filter(function (i) { return i.value !== ""; })));
    filterList.push(buildFacet(Constants.KeywordTypeId, Constants.KeywordTypeFilter, props.applyLabel, props.resetLabel, handleFilterChange, translate, (_k = (_j = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data) === null || _j === void 0 ? void 0 : _j.searchWebdam) === null || _k === void 0 ? void 0 : _k.facets.Keyword.filter(function (i) { return i.value !== ""; })));
    filterList.push(buildFacet(Constants.RegionTypeId, Constants.RegionTypeFilter, props.applyLabel, props.resetLabel, handleFilterChange, translate, (_p = (_o = (_m = (_l = axiosResponse === null || axiosResponse === void 0 ? void 0 : axiosResponse.data) === null || _l === void 0 ? void 0 : _l.searchWebdam) === null || _m === void 0 ? void 0 : _m.facets) === null || _o === void 0 ? void 0 : _o.Region) === null || _p === void 0 ? void 0 : _p.filter(function (i) { return i.value !== ""; })));
    return filterList;
}
//Build Language dropdown (languageList)
function buildLanguageList(list, translate) {
    var languageList = [];
    list === null || list === void 0 ? void 0 : list.map(function (l) {
        if (l && l.length > 0) {
            languageList.push({
                label: translate(Constants.LanguagesTypeId, l),
                value: l,
            });
        }
    });
    return languageList;
}
//#endregion
var AssetExplorerTab = function (props) {
    var _a, _b, _c, _d, _e, _f, _g;
    var _h = (0, use_state_if_mounted_1.useStateIfMounted)(true), isLoadingResponse = _h[0], setIsLoading = _h[1];
    var _j = (0, react_1.useState)(((_a = props.queryStringFilters) === null || _a === void 0 ? void 0 : _a.stickyFilters) || []), filters = _j[0], setFilters = _j[1]; //pills/sticky filters
    var _k = (0, react_1.useState)(((_b = props.queryStringFilters) === null || _b === void 0 ? void 0 : _b.foundForFilters) || []), assetTypes = _k[0], setAssetTypes = _k[1]; //'found for' filters text list
    var _l = (0, use_state_if_mounted_1.useStateIfMounted)({}), facets = _l[0], setFacets = _l[1]; //dropdown facets/filteres
    var _m = (0, use_state_if_mounted_1.useStateIfMounted)({}), resultGrid = _m[0], setResultGrid = _m[1]; //results
    var _o = (0, react_1.useState)(((_c = props.queryStringFilters) === null || _c === void 0 ? void 0 : _c.graphQlFilters) || props.graphqlVariables.filters), graphqlVariables = _o[0], setGraphQLVariables = _o[1]; //graphQL variables (dynamic)
    var _p = (0, react_1.useState)(0), skipVar = _p[0], setSkipVar = _p[1]; //results to skip for pagination
    var _q = (0, react_1.useState)(1), startRange = _q[0], setStartRange = _q[1];
    var _r = (0, react_1.useState)(1), currentPage = _r[0], setCurrentPage = _r[1];
    var _s = (0, react_1.useState)(false), isError = _s[0], setError = _s[1];
    var _t = (0, react_1.useState)(props.q), searchTerm = _t[0], setSearchTerm = _t[1]; //user search term
    var contextLang = GetLanguageNameByAbbrv(props === null || props === void 0 ? void 0 : props.contextLanguage);
    var initLang = GetLanguageNameByAbbrv((_d = props.queryStringFilters) === null || _d === void 0 ? void 0 : _d.languageFilter) ||
        contextLang ||
        "English";
    var _u = (0, react_1.useState)(initLang), language = _u[0], setLanguage = _u[1];
    var viewSpecificLanguageLabel = props.viewSpecificLanguageLabel || "{{language}}";
    var initViewLangLabel = props.viewLanguagesLabel;
    if (contextLang !== language) {
        initViewLangLabel = viewSpecificLanguageLabel.replace("{{language}}", props.findTranslation(Constants.LanguagesTypeId, language));
    }
    var _v = (0, react_1.useState)(initViewLangLabel), viewLanguageLabel = _v[0], setViewLangugeLabel = _v[1];
    var UnsupportedLanguageList = [
        {
            name: Constants.Chinese,
            prefix: Constants.ChineseAbbrv,
        },
    ];
    (0, react_1.useEffect)(function () {
        setSkipVar(0);
        setStartRange(1);
        setCurrentPage(1);
        setSearchTerm(props.q);
    }, [props.q]);
    try {
        (0, react_1.useEffect)(function () {
            var CancelToken = axios_1.default.CancelToken;
            var source = CancelToken.source();
            setIsLoading(true);
            //always add brandcenter type and language
            var variable = __spreadArray([], graphqlVariables, true);
            variable.push(props.brandcenterTypeFilter);
            variable.push({ field: "Language", value: language + "|Any" });
            //check if unsupported language is selected
            var langPrefix = props.contextLanguage;
            var unsupportedLang = UnsupportedLanguageList.find(function (l) { return l.name === language; });
            if (unsupportedLang) {
                langPrefix = unsupportedLang.prefix;
            }
            var axiosVar = {
                q: "".concat(props.q, "*"),
                top: props.pageSize,
                skip: skipVar,
                language: langPrefix,
                fields: "",
                filters: variable,
            };
            var body = JSON.stringify({
                query: props.graphqlQuery,
                variables: axiosVar,
                cancelToken: source.token,
            });
            axios_1.default
                .post(props.graphqlApiUri, body)
                .then(function (response) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                var result = {
                    resultGridData: buildResultList(response.data, props, langPrefix, language, props.q),
                    slideNumber: currentPage,
                    pageSize: props.pageSize || 0,
                    pageLabel: props.paginationLabel,
                    totalCount: ((_c = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.searchWebdam) === null || _c === void 0 ? void 0 : _c.count) || 0,
                    onPaginationChange: handlePaginationChange_1,
                };
                setResultGrid(result);
                setError(false);
                var facetList = buildFacetList(response.data, props, handleFilterChange_1, props.findTranslation);
                var dropdownFilter = {
                    tabId: (_d = props.queryStringFilters) === null || _d === void 0 ? void 0 : _d.tabPrefix,
                    filterData: {
                        filterText: props.filterTextLabel,
                        filterList: facetList,
                        resetText: props.resetAllLabel,
                        resetAllClick: function () {
                            console.log("handleClick");
                        }, //todo unused
                    },
                    stickyFilterData: {
                        filterOption: filters,
                        clearAllText: props.clearAllLabel,
                        removeFilter: handleRemoveFilter_1,
                    },
                    filterControlData: {
                        filterSummary: {
                            startAssetPageCount: startRange,
                            assetPageCount: startRange + (((_e = result === null || result === void 0 ? void 0 : result.resultGridData) === null || _e === void 0 ? void 0 : _e.length) || 0) - 1,
                            totalAssetCount: (_h = (_g = (_f = response.data) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.searchWebdam) === null || _h === void 0 ? void 0 : _h.count,
                            assetType: assetTypes === null || assetTypes === void 0 ? void 0 : assetTypes.join(", ").replace(/,\s*$/, ""),
                            searchTerm: props.q,
                            resultCountText: props.q === ""
                                ? props.resultCountTextAlt
                                : props.resultCountText,
                        },
                        languageFilter: {
                            selectedLanguage: language,
                            languageSelector: viewLanguageLabel,
                            languageList: buildLanguageList(props.languageList, props.findTranslation),
                            handleChangeLanguage: handleChangeLanguage_1,
                        },
                    },
                    handleClick: handleClearAllFilter_1,
                };
                setFacets(dropdownFilter);
                props.setTabCount((_l = (_k = (_j = response.data) === null || _j === void 0 ? void 0 : _j.data) === null || _k === void 0 ? void 0 : _k.searchWebdam) === null || _l === void 0 ? void 0 : _l.count);
                ToQueryString((_m = props.queryStringFilters) === null || _m === void 0 ? void 0 : _m.tabPrefix, props.q, graphqlVariables, GetAbbrFromLanguageName(language));
                setIsLoading(false);
                writeDDO(null, "", "", "", props.q);
            })
                .catch(function (error) {
                setError(true);
                if (axios_1.default.isCancel(error)) {
                    console.log("successfully aborted");
                }
                else {
                    console.log(error);
                }
            })
                .finally(function () { return setIsLoading(false); });
            return function () {
                // cancel the request before component unmounts
                source.cancel();
            };
        }, [searchTerm, graphqlVariables, skipVar, language]);
        //update page count label when new result is received
        (0, react_1.useEffect)(function () {
            var _a;
            var newEndRange = startRange + (((_a = resultGrid === null || resultGrid === void 0 ? void 0 : resultGrid.resultGridData) === null || _a === void 0 ? void 0 : _a.length) || 0) - 1;
            setFacets(function (prevState) {
                var _a;
                return (__assign(__assign({}, prevState), { filterControlData: __assign(__assign({}, prevState === null || prevState === void 0 ? void 0 : prevState.filterControlData), { filterSummary: __assign(__assign({}, (_a = prevState === null || prevState === void 0 ? void 0 : prevState.filterControlData) === null || _a === void 0 ? void 0 : _a.filterSummary), { assetPageCount: newEndRange }) }) }));
            });
        }, [resultGrid]);
        // update current page label when pagination is updated
        (0, react_1.useEffect)(function () {
            setResultGrid(function (prevState) { return (__assign(__assign({}, prevState), { slideNumber: currentPage })); });
        }, [currentPage]);
        //#region callback functions
        var handleFilterChange_1 = function (arr) {
            // const assetTypeStrings = CreateFoundForList(arr, props.findTranslation);
            var translatedFilters = CreateStickyFiltersList(arr, props.findTranslation);
            var graphQLFilters = CreateGraphQLVariablesList(arr);
            // setAssetTypes(assetTypeStrings);
            setFilters(translatedFilters);
            setGraphQLVariables(graphQLFilters);
            setSkipVar(0);
            setStartRange(1);
            setCurrentPage(1);
        };
        var handleRemoveFilter_1 = function (e) {
            var _a;
            var pillId = (_a = e.target.closest("a")) === null || _a === void 0 ? void 0 : _a.getAttribute("data-filterid");
            var remainingFilters = filters.filter(function (item) { return item.id !== pillId; });
            var graphQLFilters = CreateGraphQLVariablesList(remainingFilters);
            // const foundItemsForText = CreateFoundForList(
            //   remainingFilters,
            //   props.findTranslation
            // );
            setGraphQLVariables(graphQLFilters);
            // setAssetTypes(foundItemsForText);
            setFilters(remainingFilters);
            setSkipVar(0);
            setStartRange(1);
            setCurrentPage(1);
        };
        var handleClearAllFilter_1 = function () {
            var _a;
            setFilters([]);
            setAssetTypes([]);
            setGraphQLVariables([]);
            setSkipVar(0);
            setStartRange(1);
            setCurrentPage(1);
            setLanguage(GetLanguageNameByAbbrv(props === null || props === void 0 ? void 0 : props.contextLanguage) || "English");
            setViewLangugeLabel(props.viewLanguagesLabel);
            ToQueryString((_a = props.queryStringFilters) === null || _a === void 0 ? void 0 : _a.tabPrefix, props.q, [], props.contextLanguage);
        };
        var handlePaginationChange_1 = function (page) {
            var newSkipVar = (page - 1) * props.pageSize;
            setSkipVar(newSkipVar);
            setStartRange(newSkipVar + 1);
            setCurrentPage(page);
        };
        var handleChangeLanguage_1 = function (lang) {
            setLanguage(lang);
            setViewLangugeLabel(viewSpecificLanguageLabel.replace("{{language}}", props.findTranslation(Constants.LanguagesTypeId, lang)));
            setSkipVar(0);
            setStartRange(1);
            setCurrentPage(1);
        };
        //#endregion
        if (isLoadingResponse) {
            return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "image-wrapper" }, { children: (0, jsx_runtime_1.jsx)("img", { src: loading_svg_1.default, width: "5%", height: "auto", alt: "" }) })));
        }
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: isError ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: "richtext error-text" }, { children: (0, jsx_runtime_1.jsx)("h3", { dangerouslySetInnerHTML: { __html: props.gridLoadErrorText } }) }))) : ((_e = resultGrid === null || resultGrid === void 0 ? void 0 : resultGrid.resultGridData) === null || _e === void 0 ? void 0 : _e.length) > 0 ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(AssetDropdownFilter_1.default, __assign({}, facets)), (0, jsx_runtime_1.jsx)(AssetResultsGrid_1.default, __assign({}, resultGrid))] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(brandcenter_asset_filter_control_1.default, __assign({}, facets.filterControlData)) }), ((_g = (_f = facets === null || facets === void 0 ? void 0 : facets.stickyFilterData) === null || _f === void 0 ? void 0 : _f.filterOption) === null || _g === void 0 ? void 0 : _g.length) > 0 && ((0, jsx_runtime_1.jsx)(StickyFilters_1.default, { stickyFilterData: facets.stickyFilterData, handleClearAll: handleClearAllFilter_1, handleRemoveFilter: facets.stickyFilterData.removeFilter })), (0, jsx_runtime_1.jsx)("div", { className: "richtext", dangerouslySetInnerHTML: { __html: props.noResultText } })] })) }));
    }
    catch (error) {
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "richtext error-text" }, { children: (0, jsx_runtime_1.jsx)("h3", { dangerouslySetInnerHTML: { __html: props.gridLoadErrorText } }) })) }));
    }
};
exports.default = AssetExplorerTab;
//# sourceMappingURL=tab.js.map